import { z } from "zod";

const usersSchema = z.object({
	name: z.string().min(3).max(255),
	username: z.string().min(3).max(23),
	bio: z.string().nullish(),
	icon: z.string(),
	role: z.enum(["user", "admin"]).default("user"),
	image: z.string().nullish(),
	phone: z
		.string()
		.regex(
			/^(?:(?:\+|00)?(55)\s?)?(?:(?:\(?[1-9][0-9]\)?)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/,
			"Informe um número de telefone válido"
		),
	email: z.string().email().max(55),
	password: z.string().min(6).max(120),
});

const usersUpdateSchema = usersSchema.partial();

export type iEdit = z.infer<typeof usersUpdateSchema>;

export { usersUpdateSchema };
